<template>
  <div :class="getClassName('quantity')">
    <v-text-field
      :class="getClassName('quantity__field')"
      type="number"
      min="1"
      v-model="internalValue"
      outlined
      hide-details
      dense
    />
    <span :class="getClassName('quantity__unit')" v-if="item.unit !== ''">{{ item.unit }}</span>
  </div>
</template>

<script>
import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value.quantity;
      },
      set(newValue) {
        if (this.value.quantity !== newValue) this.$emit('input', { ...this.value, quantity: newValue });
      },
    },
  },
};
</script>

<style lang="scss">
.quantity {
  &__field {
    .v-input__slot {
      min-height: 36px !important;
    }
    &--sp {
      .v-input__slot {
        min-height: 20px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '../../_sass/variables';

.quantity {
  display: flex;
  align-items: center;
  &--sp {
    justify-content: center;
  }
  &__field {
    width: 200px;
    border-color: $color__line--item;
    border-radius: 0px;
    flex: 0 0 auto;
    &--sp {
      width: 50px;
    }
  }
  &__unit {
    margin-left: 0.5em;
    &--sp {
      font-size: 1rem;
    }
  }
}
</style>
